import BigNumber from "bignumber.js";

export default {
  /**
   * base64转为文件对象
   */
  base64ToFile(urlData, fileName) {
    let arr = urlData.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bytes = atob(arr[1]); // 解码base64
    let n = bytes.length
    let ia = new Uint8Array(n);
    while (n--) {
      ia[n] = bytes.charCodeAt(n);
    }
    return new File([ia], fileName, {type: mime});
  },
  /**
   * 构建sms安全信息详情页地址
   * 增加时间戳，避免由于浏览器缓存导致走cas的第一个请求不是activity.html
   */
  buildSmsActivityDetailUrl: function (activityId) {
    return process.env.smsHost + "/sms/uui/com/sms/search/activity.html?activityId=" + activityId + "&keep=true";
  },
  /**
   * 填充0
   * @param num 数字
   * @param n 填充至n位
   */
  prefixZero: function (num, n) {
    return (Array(n).join(0) + num).slice(-n);
  },

  getRiskLevelBgColor: function (level) {
    switch (level) {
      case "RED":
        return "risk-level-bg-color-red";
      case "YELLOW":
        return "risk-level-bg-color-yellow";
      case "BLUE":
        return "risk-level-bg-color-blue";
      case "GREEN":
        return "risk-level-bg-color-green";
      case "ORANGE":
        return "risk-level-bg-color-orange";
      default:
        return "default-bg-color";
    }
  },
  getRiskLevelColor: function (level) {
    switch (level) {
      case "RED":
        return "risk-level-color-red";
      case "YELLOW":
        return "risk-level-color-yellow";
      case "BLUE":
        return "risk-level-color-blue";
      case "GREEN":
        return "risk-level-color-green";
      case "ORANGE":
        return "risk-level-color-orange";
    }
  },
  /**
   * 从一堆数组中选出最大值
   */
  getMax() {
    let result = [];
    for (let i = 0; i < arguments.length; i++) {
      result = result.concat(arguments[i].map(item => item.value));
    }
    return Math.max.apply(null, result);
  },
  /**
   * 乘法
   */
  multiply(a, b) {
    return new BigNumber(a).multipliedBy(b).toNumber();
  },
  minus(a, b) {
    return new BigNumber(a).minus(b).toNumber();
  },
  /**
   * 调整右y轴刻度，使其与左y轴对其
   * @param chart 图表
   * @param maxRight 右y轴最大值
   */
  adjustYaxis(chart, maxRight) {
    let scope = chart.getModel().getComponent('yAxis').axis.scale._extent;
    let interval = chart.getModel().getComponent('yAxis').axis.scale._interval;
    let splitNumber = new BigNumber(scope[1]).div(interval)

    let multiple;
    let maxLeft = scope[1];

    //调整后的右y轴最大值
    let adjustMaxRight;

    if (maxLeft >= maxRight) {
      for (multiple = 100; multiple > 0; multiple--) {
        adjustMaxRight = new BigNumber(maxLeft).div(multiple).toNumber();
        if (adjustMaxRight > maxRight && maxLeft * 10000 % multiple === 0 && adjustMaxRight * 10000 % splitNumber === 0)
          break;
      }
    } else {
      for (multiple = 1; multiple < 100; multiple++) {
        adjustMaxRight = new BigNumber(maxLeft).multipliedBy(multiple).toNumber();
        if (adjustMaxRight > maxRight && maxLeft * 10000 % (multiple) === 0 && adjustMaxRight * 10000 % splitNumber === 0)
          break;
      }
    }

    let option = chart.getOption();
    option.yAxis[1].interval = new BigNumber(adjustMaxRight).div(splitNumber).toNumber();
    option.yAxis[1].max = adjustMaxRight;
    chart.setOption(option);
  },
}



// WEBPACK FOOTER //
// ./src/utils/util.js